// @ts-nocheck
import React, { useEffect } from "react";
// import { renderRoutes } from "react-router-config";
import { Outlet, Navigate } from "react-router";
import { useLocation } from "react-router-dom";
import { startUsageTracker, trackPageView } from '@/utils/usageTracker';
import { startSessionRecorder } from '@/utils/sessionRecorder';
import PageClicksFooter from '@/components/PageClicksFooter';
import { LogOut } from 'lucide-react';
import Header from "../../components/Header/Header";
import { useAuth, useUser } from '@/auth/clerkShim'
import whiteLogo from '../../assets/icons/black_logo.png';
import '../../index.css';
import '../../App.css';

// (The legacy react-router-config `route` prop is gone — the router renders
// this with no props and children come through <Outlet />.)
function CreateOrganizationLayout() {
  const { userId, isLoaded, signOut } = useAuth();
  const { user } = useUser();
  const location = useLocation();

  // Owner-only usage analytics beacon (fail-silent; see utils/usageTracker.ts).
  // Covers the /create onboarding funnel — the flow with the historical drop-off.
  useEffect(() => { startUsageTracker(); }, []);
  useEffect(() => { trackPageView(location.pathname); }, [location.pathname]);
  // rrweb session recording, masked inputs (fail-silent; INT-0035).
  useEffect(() => { startSessionRecorder(); }, []);

  // Wait for auth to resolve before deciding (avoids a redirect flash), then send
  // signed-out visitors to the sign-in page instead of a dead-end "Not signed in".
  if (!isLoaded) return null;
  if (!userId) {
    return <Navigate to="/sign-in" replace />;
  }

  // Header logo links to the marketing site (localhost admin root when running
  // locally). Detect the env from the runtime host, not a build flag.
  const { hostname } = window.location;
  const isLocalEnv = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.localhost');
  const homeUrl = isLocalEnv ? 'http://localhost:3030' : 'https://www.staty.io';

  return (
    <>
      <header className="flex items-center justify-between h-16 px-4 border-b shrink-0 md:px-6">
        {/* Left spacer balances the sign-out control so the logo stays centered. */}
        <div className="flex-1" aria-hidden="true" />
        <div className="text-center">
          <a href={homeUrl} aria-label="Staty home" className="text-lg font-bold inline-block cursor-pointer">
            <img
              style={{ height: "35px", margin: "20px 10px 20px 0px" }}
              src={whiteLogo} alt="Staty" />
          </a>
        </div>
        {/* Wrong-account escape hatch (owner request 2026-09-29). Deliberately
            LOW-emphasis — muted text, no button fill — so it never competes
            with the create flow's own actions: signing out is a rescue here,
            not a goal. The email says WHY you'd use it (signed in as the
            wrong account); it yields to the control on narrow screens. */}
        <div className="flex flex-1 items-center justify-end gap-2 text-xs text-muted-foreground">
          {user?.primaryEmailAddress?.emailAddress ? (
            <span className="hidden truncate sm:inline max-w-[16rem]" title={user.primaryEmailAddress.emailAddress}>
              Signed in as {user.primaryEmailAddress.emailAddress}
            </span>
          ) : null}
          <button
            type="button"
            onClick={signOut}
            className="inline-flex shrink-0 items-center gap-1 rounded px-1.5 py-1 text-xs text-muted-foreground transition-colors hover:text-foreground hover:underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <LogOut className="h-3.5 w-3.5" aria-hidden="true" />
            Sign out
          </button>
        </div>
      </header>
      <div id="soot" className="mx-auto flex w-full min-h-screen flex-col items-center justify-center pb-64">
        {/* <Header league={{ name: "Staty" }} location={this.props.location} match={this.props.match} /> */}
        {/* {renderRoutes(route.routes)} */}
        <Outlet />
        {/* Owner-only "+" click-analytics footer — must stay the LAST in-flow
            element on every admin page (CLAUDE.md → Admin usage tracking;
            INT-0034). */}
        <PageClicksFooter />
      </div>
    </>
  );

}

export default CreateOrganizationLayout;
